module.exports = __webpack_public_path__ + "static/media/login-icon.f085dbe1.png";